import React from "react";
import { Download, Share, X } from "lucide-react";
import usePwaInstall from "@/hooks/usePwaInstall";

export default function AdminPwaInstallBanner() {
  const { showBanner, canPrompt, ios, promptInstall, dismiss } = usePwaInstall();

  if (!showBanner) return null;

  return (
    <div
      className="border-b border-white/10 bg-[#0a0a0a] px-3 py-2 flex items-start gap-2"
      data-testid="admin-pwa-install-banner"
    >
      <Download className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
      <div className="min-w-0 flex-1">
        {ios && !canPrompt ? (
          <p className="text-xs font-['Manrope'] text-white/70 leading-snug">
            Install the staff app: tap{" "}
            <Share className="inline w-3.5 h-3.5 text-blue-300 align-text-bottom" /> Share, then{" "}
            <span className="text-white">Add to Home Screen</span>.
          </p>
        ) : (
          <div className="flex flex-wrap items-center gap-2">
            <p className="text-xs font-['Manrope'] text-white/70">Install the staff app on this phone.</p>
            {canPrompt && (
              <button
                type="button"
                onClick={promptInstall}
                className="min-h-11 px-3 text-xs font-['Manrope'] font-semibold bg-blue-500 hover:bg-blue-600 text-white"
                data-testid="admin-pwa-install-btn"
              >
                Install staff app
              </button>
            )}
          </div>
        )}
      </div>
      <button
        type="button"
        aria-label="Dismiss install prompt"
        onClick={dismiss}
        className="inline-flex items-center justify-center min-h-11 min-w-11 text-white/40 hover:text-white"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
